import React from 'react';
import styles from './index.scss';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: string;
  size?: number | string;
}

const Icon: React.FC<IconProps> = ({
  name,
  size = 24,
  className,
  ...props
}) => {
  React.useEffect(() => {
    // 确保 sprite.svg 已被加载
    const spriteUrl = '/icons/sprite.svg';
    if (!document.getElementById('svg-sprite')) {
      fetch(spriteUrl)
        .then((res) => res.text())
        .then((text) => {
          const div = document.createElement('div');
          div.id = 'svg-sprite';
          div.style.display = 'none';
          div.innerHTML = text;
          document.body.appendChild(div);
        });
    }
  }, []);

  return (
    <svg
      className={`${styles.icon} ${className || ''}`}
      width={size}
      height={size}
      {...props}
    >
      <use href={`#${name}`} />
    </svg>
  );
};

export default Icon;
